import { useForm } from '@/features/pos/components/CustomerProfile/form'
import { FormDefaultValues } from '@/features/pos/components/CustomerProfile/form/types'
import { FC, ReactNode } from 'react'
import { FormProvider } from 'react-hook-form'

interface FormProps {
    children: ReactNode
    defaultValues: FormDefaultValues
    isDelivery: boolean
}

const Form: FC<FormProps> = ({ children, defaultValues, isDelivery }) => {
    const methods = useForm(defaultValues, isDelivery)

    return <FormProvider {...methods}>{children}</FormProvider>
}

export default Form
